import './InputLabel.css'
import cx from 'classnames'
import { InfoTooltip } from '../InfoTooltip/InfoTooltip'

const sizeClasses = {
  sm: 'label-sm',
  md: 'label-md'
}

export function Label({
  children,
  sizeType = 'sm',
  htmlFor,
  className,
  required,
  tooltip,
  tooltipPlacement = 'top',
  tooltipSize = 'small'
}: {
  children: React.ReactNode
  sizeType?: 'sm' | 'md'
  htmlFor?: string
  className?: string
  required?: boolean
  tooltip?: React.ReactNode
  tooltipPlacement?: 'top' | 'bottom'
  tooltipSize?: 'small' | 'medium' | 'large'
}) {
  return (
    <label className={cx('label-base', sizeClasses[sizeType], className)} htmlFor={htmlFor}>
      {children}
      {required && <span className="label-required">*</span>}
      {tooltip && <InfoTooltip content={tooltip} position={tooltipPlacement} size={tooltipSize} />}
    </label>
  )
}
